import styled from 'styled-components';
import {Button, Checkbox, Input} from "antd";

export const CouponHeader = styled.div`
  margin-top: 32px;
  height: 168px;
  
  div {
    height: 168px;
  }
  
  img {
    object-fit: cover !important;
    object-position: center;
  }
`

export const CanalPlusCouponHeader = styled.div`
  @media screen and (max-width: 768px) { 
    object-fit: cover !important;
  }

  @media screen and (min-width: 768px) { 
    img { 
      object-fit: contain; 
    } 
  }
`

export const CouponContentWrapper = styled.div`   
  h1 {
    text-align: center;
    margin: 0 0 32px;
    word-break: keep-all;
  }
  
  h2 {
    margin: 0 0 20px;
  }
  
  p {
    margin: 0 0 12px;
  }

  @media screen and (max-width: 768px) {
    padding: 0 16px;
  }
`

export const CanalPlusCouponContentWrapper = styled.div`
  p {
    margin: 12px 0 !important;
  }

  @media screen and (max-width: 768px) {
    padding: 16px;
  }

  .ant-form-item-label {
    padding-top: 4px;
    padding-bottom: 0;
  }
`

export const CouponButtonForm = styled(Button)`
  background-color: #DC0D1F;
  border-color: #DC0D1F;
  border-radius: 4px;
  padding: 10px 21px;
  height: fit-content;
  
  &:hover, &:active, &:focus {
    background-color: #DC0D1F;
    border-color: #DC0D1F;
  }
  
  span {
    font-weight: bold;
    line-height: 1.5;
  }
`

export const CouponCheckboxForm = styled(Checkbox)`
  margin-top: 16px;
  
  a {
    color: black;
    font-weight: bold;
  }
`

export const CouponInputDisabled = styled(Input)`
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
`
